import React, { useState, useEffect } from 'react';
import { useNavigate, useResolvedPath } from 'react-router-dom';
import styles from './tableTabs.module.css';

// components
import IconButton from '../IconButton/IconButton';
import Filters from '../Filters';
import Button from '../Button/Button';

// icons
import fastsearch from '../../brand/generated/fastSearch.svg';
import advancedSearchCameo from '../../brand/generated/advancedSearch.svg';
import advancedSearchDark from '../../brand/generated/advancedSearchDark.svg';
import plus from '../../brand/generated/buttonIcons/plus.svg';
import calendar from '../../brand/generated/buttonIcons/calendar.svg';
import Permission from '../Permission';
import { PERMISSION_CAN_CREATE_LEADS } from '../../constants/roles';

const TableTabs = ({
  to,
  setFilter,
  value,
  handleSearchParams,
  handleFastSearchParams,
  filterComponent,
  setValue,
  navigate,
  button,
  buttons,
  inputPlaceholder,
  permission = 'all',
  appliedFilters,
  onRemoveFilter,
  defaultFiltersOpen,
  // false â ÑÑÑÐ°Ð½Ð¸ÑÐ° Ð±ÐµÐ· ÑÐ°ÑÑÐ¸ÑÐµÐ½Ð½Ð¾Ð³Ð¾ Ð¿Ð¾Ð¸ÑÐºÐ° (ÑÐ¿Ð¸ÑÐ¾Ðº Ð¸Ð· Ð¾Ð´Ð½Ð¾Ð¹ ÐºÐ¾Ð»Ð¾Ð½ÐºÐ¸-ÐºÐ»ÑÑÐ°)
  advancedSearch = true,
  // false â Ð±ÐµÐ· ÐºÐ½Ð¾Ð¿ÐºÐ¸ Â«ÐÐ¾Ð±Ð°Ð²Ð¸ÑÑÂ» (ÑÑÑÐ°Ð½Ð¸ÑÐ° ÑÐ¾Ð»ÑÐºÐ¾ Ð´Ð»Ñ ÑÑÐµÐ½Ð¸Ñ)
  addButton = true,
}) => {
  const navigation = useNavigate();
  const { pathname } = useResolvedPath(to);
  // ÐÑÐ¸ÑÐ»Ð¸ Ð¿Ð¾ ÑÑÑÐ»ÐºÐµ Ñ ÑÐ¸Ð»ÑÑÑÐ°Ð¼Ð¸ â Ð¿Ð°Ð½ÐµÐ»Ñ ÑÑÐ°Ð·Ñ ÑÐ°ÑÐºÑÑÑÐ°: Ð¸Ð½Ð°ÑÐµ Ð·Ð½Ð°ÑÐµÐ½Ð¸Ñ Ð²Ð¸Ð´Ð½Ñ
  // ÑÐ¾Ð»ÑÐºÐ¾ Ð² ÑÑÑÐ¾ÐºÐµ Ð¿ÑÐ¸Ð¼ÐµÐ½ÑÐ½Ð½ÑÑ, Ð° Ð¿Ð¾Ð»Ñ Ð¿Ð¾Ð´ Ð½Ð¸Ð¼Ð¸ Ð²ÑÐ³Ð»ÑÐ´ÑÑ Ð¿ÑÑÑÑÐ¼Ð¸.
  const [showFilters, setShowFilters] = useState(!!defaultFiltersOpen);
  const [filtersKey, setFiltersKey] = useState(0);

  // Ð¡Ð±ÑÐ¾Ñ â Ð¾Ð´Ð¸Ð½ Ð¸ ÑÐ¾Ñ Ð¶Ðµ Ð¸ Ð´Ð»Ñ ÐºÐ½Ð¾Ð¿ÐºÐ¸ Ð² Ð¿Ð°Ð½ÐµÐ»Ð¸, Ð¸ Ð´Ð»Ñ ÑÑÑÐ¾ÐºÐ¸ Ð¿ÑÐ¸Ð¼ÐµÐ½ÑÐ½Ð½ÑÑ ÑÐ¸Ð»ÑÑÑÐ¾Ð²:
  // ÑÐ¾ÑÐ¼Ñ Ð½Ð°Ð´Ð¾ Ð½Ðµ ÑÐ¾Ð»ÑÐºÐ¾ Ð¾ÑÐ¸ÑÑÐ¸ÑÑ Ð² ÑÑÐµÐ¹ÑÐµ, Ð½Ð¾ Ð¸ Ð¿ÐµÑÐµÐ¼Ð¾Ð½ÑÐ¸ÑÐ¾Ð²Ð°ÑÑ (ÐºÐ»ÑÑ), Ð¸Ð½Ð°ÑÐµ Ð²
  // ÑÐµÐ»ÐµÐºÑÐ°Ñ Ð¾ÑÑÐ°ÑÑÑÑ Ð²ÑÐ±ÑÐ°Ð½Ð½ÑÐµ Ð·Ð½Ð°ÑÐµÐ½Ð¸Ñ.
  const resetFilters = () => {
    setFiltersKey((prev) => prev + 1);
    handleSearchParams(true);
  };

  const fastSearch = (e) => {
    if (e.keyCode === 13 || e.type === 'click') {
      setFilter(value);
      // handleFastSearchParams(value);
    }
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.firstRow}>
        <div
          style={{
            display: 'flex',
            gap: 15,
          }}
        >
          {addButton && (
            <Permission permission={permission}>
              <IconButton text={button} icon={plus} onClick={navigate} />
            </Permission>
          )}
          {buttons &&
            buttons?.map((button) => (
              <IconButton text={button.text} icon={button.icon || plus} onClick={button.onClick} />
            ))}
        </div>
        <div className={styles.input}>
          <img src={fastsearch} alt="Icon" />
          <input
            value={value}
            type="text"
            placeholder={inputPlaceholder}
            onChange={(e) => setValue(e.target.value)}
            onKeyDown={fastSearch}
          />
        </div>
        <Button text={'ÐÐ°Ð¹ÑÐ¸'} onClick={fastSearch} fill={true} />
        {advancedSearch && (
          <button
            style={pathname === '/records' ? { marginRight: 'auto' } : null}
            className={styles.advancedSearch}
            onClick={() => setShowFilters((prev) => !prev)}
          >
            <img src={showFilters ? advancedSearchDark : advancedSearchCameo} alt="Search" />
            <p style={showFilters ? { color: 'var(--brand-dark)' } : null}>Ð Ð°ÑÑÐ¸ÑÐµÐ½Ð½ÑÐ¹ Ð¿Ð¾Ð¸ÑÐº</p>
          </button>
        )}
        {pathname === '/records' && (
          <IconButton text={'ÐÑÐºÑÑÑÑ ÐºÐ°Ð»ÐµÐ½Ð´Ð°ÑÑ'} icon={calendar} onClick={() => navigation('/records/service')} />
        )}
      </div>
      {appliedFilters?.length > 0 && (
        <div className={styles.applied}>
          <span className={styles.appliedTitle}>Ð¤Ð¸Ð»ÑÑÑÑ:</span>
          {appliedFilters.map((filter) => (
            <span className={styles.chip} key={filter.name}>
              {filter.label}: <b>{filter.text}</b>
              {onRemoveFilter && (
                <button
                  type="button"
                  className={styles.chipRemove}
                  title={`Ð£Ð±ÑÐ°ÑÑ ÑÐ¸Ð»ÑÑÑ Â«${filter.label}Â»`}
                  onClick={() => onRemoveFilter(filter.name)}
                >
                  Ã
                </button>
              )}
            </span>
          ))}
          <button type="button" className={styles.appliedReset} onClick={resetFilters}>
            Ð¡Ð±ÑÐ¾ÑÐ¸ÑÑ
          </button>
        </div>
      )}
      {showFilters && React.cloneElement(filterComponent, { key: filtersKey })}
      {showFilters && (
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button text={'Ð¡Ð±ÑÐ¾ÑÐ¸ÑÑ Ð²ÑÐµ'} onClick={resetFilters} />
          <Button text={'ÐÐ°Ð¹ÑÐ¸'} onClick={() => handleSearchParams(false)} fill={true} />
        </div>
      )}
    </div>
  );
};

export default TableTabs;
